import { navigate } from 'hookrouter'
import React, { FC, useEffect, useState  } from 'react'
import { Button, Col, Row } from 'react-bootstrap'
// import { BackButton } from 'components/BackButton/BackButton'
import { ProjectTemplateDisplay } from 'components/ProjectTemplateDisplay'
import { ProjectTemplatesList } from 'components/ProjectTemplatesList'
import { ProjectRolesList } from 'components/ProjectRolesList'
import {
  CompanyIdUrlParam,
  TemplateDocument,
  ProjectIdUrlParam,
  TemplateIdUrlParam,
} from 'types'
import { ProjectStatus } from 'components/ProjectStatus'
import { useProjectsForCompany } from 'hooks/useProjectsForCompany'
import { useAppContext } from 'state/context'
import { getPermissionsList } from 'state/async_actions'
import { usePermissions } from 'hooks/useCompanyManagers'

export const MissingTemplateText = 'Please select a Template/Directory!'
export const addNewTemplateLinkText = 'New Template Document'
export const addNewFolderLinkText = 'Add New Folder'

export const newTemplatePath = (companyId: number, projectId: number) =>
  `/company/${companyId}/project/${projectId}/new_template_document`

  export const projectPath = (companyId: number, projectId: number) =>
  `/company/${companyId}/project/${projectId}`

  export const newTemplateDirectoryPath = (companyId: number, projectId: number, directoryId?:number | undefined) =>
  `/company/${companyId}/project/${projectId}/directory/${directoryId}/new_template_document`

export const newFolderPath = (companyId: number, projectId: number, templateDocumentId: number) =>
  `/company/${companyId}/project/${projectId}/directory/${templateDocumentId}/new_folder`

type UrlParams = TemplateIdUrlParam & CompanyIdUrlParam & ProjectIdUrlParam

export const ProjectDirectoryDisplay: FC<UrlParams> = ({
  companyId,
  projectId,
  templateDocumentId,
}) => {
  const [activeTemplate, setActiveTemplate] = useState<
  TemplateDocument | undefined
>()
useEffect(() => {
  setActiveTemplate(undefined)
}, [setActiveTemplate, projectId])
let userRoleType: any = 1;
const [, dispatch] = useAppContext()
const projectList = useProjectsForCompany(companyId)
const project:any = projectList.find((company:any) => company.id === projectId) || {}

  if (project.isCompanyManager)
    userRoleType = 1;
  else if (project.isProjectManager)
    userRoleType = 2;
  else if (project.isProjectCoordinator)
    userRoleType = 5;
  else if (project.isSuperForeman)
    userRoleType = 3;
  else if (project.isSubCordinator)
    userRoleType = 4;
    
  const navToNewTemplateDocument = () =>{
    if(templateDocumentId)
     return navigate(newTemplateDirectoryPath(companyId, projectId, templateDocumentId))
    else
      return navigate(newTemplatePath(companyId, projectId))
  }
useEffect(() => {
  if(companyId)
    getPermissionsList(dispatch, companyId, userRoleType)
}, [dispatch, projectId, userRoleType])

const permissionsList:any = usePermissions(userRoleType);

// const navToNewFolderCreation = () =>
//     navigate(newFolderPath(companyId, projectId, templateDocumentId))

    return (
    <>
      <Row>
      <Col lg={2}>
        <ProjectRolesList companyId={companyId} projectId={projectId} templateDocumentId={templateDocumentId}></ProjectRolesList>
        <ProjectTemplatesList
          onClick={setActiveTemplate}
          activeTemplate={activeTemplate}
          companyId={companyId}
          projectId={projectId}
          template_directory_id={templateDocumentId}
          hideActions={true}
        />
        {<div style= {{width: '128%'}}>
      {(permissionsList?.template_document?.can_create && project?.status == 'active') &&<Button
        className="mb-3 btn-icon-plus"
        onClick={navToNewTemplateDocument}
        block>
        {addNewTemplateLinkText}
      </Button>}
      {/* {(permissionsList?.template_document?.create_folder_within_project && project?.status == 'active') && <Button
        className="mb-3 btn-icon-plus"
        onClick={navToNewFolderCreation}
        block>
        {addNewFolderLinkText}
      </Button>} */}
      </div>}
      {(project?.isCompanyManager || project?.isProjectManager || project?.isProjectCoordinator) && <ProjectStatus project={project}/>}
      </Col>
      { activeTemplate?.isDirectory ? 
        null:
        (<Col>
          <ProjectTemplateDisplay
            templateDocument={activeTemplate}
            companyId={companyId}
            projectId={projectId}
            setActiveTemplate={setActiveTemplate}
          />
        </Col>)
      }
    </Row>
    </>
  )
}
